<template>
  <nav class="bg-neutral text-neutral-content">
    <div class="navbar container mx-auto">
      <div class="navbar-start">
        <label for="side-drawer" class="btn btn-ghost drawer-button">
          <Icon icon="ic:round-menu" class="text-2xl" />
        </label>

        <div class="flex-1">
          <a
            href="/"
            class="btn btn-ghost-underline normal-case font-medium text-xl font-serif"
          >
            inscrib.io
          </a>
        </div>
      </div>

      <!-- <div class="navbar-center"> -->
      <!-- </div> -->

      <div class="navbar-end">
        <div v-if="backend.userLoggedIn" class="join">
          <a
            href="/account/"
            class="btn btn-square btn-ghost-underline join-item w-20 normal-case"
          >
            @{{ backend.user?.username }}
          </a>
          <a
            :href="logoutUrl"
            class="btn btn-square btn-ghost-underline join-item w-20 normal-case"
          >
            Log out
          </a>
        </div>
        <div v-else class="join">
          <a
            :href="loginUrl"
            class="btn btn-square btn-ghost-underline join-item w-20 normal-case"
          >
            Log in
          </a>
          <a
            :href="signupUrl"
            class="btn btn-square btn-ghost-underline join-item w-20 normal-case"
          >
            Sign up
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useBackendStore } from "@/stores";

const backend = useBackendStore();

// Make sure we know which user is logged in
backend.fetchUser();

const logoutUrl = `/account/logout?next=${window.location.pathname}`;
const loginUrl = `/account/login?next=${window.location.pathname}`;
const signupUrl = `/account/signup?next=${window.location.pathname}`;
</script>

<style scoped>
.btn {
  @apply hover:bg-transparent;
}
</style>
